<template>
    <div class="main">
        <div class="map" id="map" :style="'width:'+width+'px;height:'+height+'px'"></div>
    </div>
</template>

<script>
import L from 'leaflet';
import {tiledMapLayer} from '@supermap/iclient-leaflet';
import 'leaflet-draw'
export default {
    name:'base-map',
    props: ['width','height','mapType'],
    data(){
        return{
            mapView:null,
            resultLayer: null,
            drawData: {
                latLngs:[]
            }
        }
    },
    mounted(){
        this.initMap()
    },
    created(){
        this.initMap()
    },
    computed:{

    },
    components: {
        
    },
    methods:{
        initMap(){
            console.log("地图初始化！",this.width,this.height,this.mapType)
            switch(3){
                case 1:
                    this.initBaseMap()
                    break;
                case 2:
                    this.initLayerCheckMap()
                    break;
                case 3:
                    this.initDrawMap()
                    break;
                default:
                    this.initBaseMap();
            }
        },
        //单个矢量瓦片图层
        initBaseMap(){
            this.mapView = L.map('map', {
                crs: L.CRS.EPSG4326,
                center: [0, 0],
                maxZoom: 18,
                zoom: 1,
                zoomControl: false
            });
            var url = "https://iserver.supermap.io/iserver/services/map-world/rest/maps/World";
            tiledMapLayer(url).addTo(this.mapView);
        },
        //图层切换
        initLayerCheckMap(){
            var url ="https://iserver.supermap.io";
            var China = tiledMapLayer(url + '/iserver/services/map-china400/rest/maps/China',{noWrap:true});
            var ChinaDark = tiledMapLayer(url + '/iserver/services/map-china400/rest/maps/ChinaDark', {noWrap:true});
            this.mapView = L.map('map', {
                // crs: L.CRS.EPSG4326,
                center: [0, 0],
                maxZoom: 18,
                zoom: 1,
                zoomControl: false,
                layers:[China]
            });
            var baseMaps = { "China": China, "ChinaDark": ChinaDark };
            L.control.layers(baseMaps).addTo(this.mapView);
        },
        //可绘制地图
        initDrawMap(){
            let thisVue = this
            var host = window.isLocal ? window.server : "https://iserver.supermap.io";
            var url = host + "/iserver/services/map-china400/rest/maps/China";
            this.mapView = L.map('map', {
                center: [33, 114],
                zoom: 4
            });
            tiledMapLayer(url).addTo(this.mapView);

            var editableLayers = new L.FeatureGroup();
            this.mapView.addLayer(editableLayers);
            var options = {
                position: 'topleft',
                draw: {
                    //多线
                    polyline: {},
                    //多边形
                    polygon: {},
                    //圆圈
                    circle: false,
                    //矩形
                    rectangle: {},
                    //标记
                    marker: false,
                    //圆形标记
                    circlemarker: false,
                    //移除
                    remove: {}
                },
                edit: {
                    featureGroup: editableLayers,
                    remove: true
                }
            };
            var drawControl = new L.Control.Draw(options);
            this.mapView.addControl(drawControl);
            // this.handleMapEvent(drawControl._container, map);
            this.mapView.on(L.Draw.Event.EDITED , function (e) {
                console.log("CREATED",e)
                let layers = e.getLayers()
                layers.forEach(e=>{
                    console.log(e)
                })
            });
            this.mapView.on(L.Draw.Event.CREATED, function (e) {
                console.log("CREATED",e)
                var type = e.layerType,
                    layer = e.layer;
                //生成的是标记
                if (type === 'marker') {
                    layer.bindPopup('A popup!');
                }
                //生成的是多线
                if(type ==='polyline'){
                    let arr = e.layer.getLatLngs()
                    console.log(arr)
                    thisVue.drawData.latLngs = arr;
                }
                //生成的是多边型
                if(type ==='polygon'){
                    let arr = e.layer.getLatLngs()
                    console.log(arr)
                    thisVue.drawData.latLngs = arr;
                }
                //生成的是矩形
                if(type ==='rectangle'){
                    let arr = e.layer.getLatLngs()
                    console.log(arr)
                    thisVue.drawData.latLngs = arr;
                }

                editableLayers.addLayer(layer);
            });
        },
        //添加zoom
        addZoom(){
            L.control.zoom().addTo(this.mapView);
        },
        //添加区块
        addPolygons(arrs){
            arrs.forEach(element => {
                var polygon = L.polygon(element);
                polygon.addTo(this.mapView);
            });
        },
        //添加比例尺
        addRuler(){
            L.control.scale().addTo(this.mapView);
        },
        //获取画出来的点
        getDrawPoint(){
            return this.drawData.latLngs;
        }

    }
}
</script>

<style lang="scss" scoped>
.map{
    // width: 800px;
    // height: 800px;
    // background-color: red;
}
.sr-only {
    display: none;
  }
</style>